enum SearchType {
    Address = "Address",
    Deals = "Deals",
    Leads = "Leads",
}

export default SearchType;